import React from 'react';
import { NavArrowLeft, NavArrowRight } from 'iconoir-react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    if (!showEllipsis) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }

    return pages;
  };

  return (
    <div className="flex items-center justify-between">
      <p className="text-sm text-surface-500">
        Page <span className="font-semibold text-surface-700">{currentPage}</span> of{' '}
        <span className="font-semibold text-surface-700">{totalPages}</span>
      </p>

      <div className="flex items-center gap-1">
        {/* Previous Button */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`
            inline-flex items-center justify-center w-9 h-9 rounded-lg
            text-sm font-medium transition-all duration-200
            ${currentPage === 1
              ? 'text-surface-300 cursor-not-allowed'
              : 'text-surface-600 hover:bg-surface-100'
            }
          `}
        >
          <NavArrowLeft strokeWidth={2} className="w-4 h-4" />
        </button>

        {/* Page Numbers */}
        {getPageNumbers().map((page, index) => (
          <React.Fragment key={index}>
            {page === '...' ? (
              <span className="w-9 h-9 flex items-center justify-center text-surface-400">
                ...
              </span>
            ) : (
              <button
                onClick={() => onPageChange(page)}
                className={`
                  w-9 h-9 rounded-lg text-sm font-medium transition-all duration-200
                  ${currentPage === page
                    ? 'bg-primary-600 text-white shadow-glow'
                    : 'text-surface-600 hover:bg-surface-100'
                  }
                `}
              >
                {page}
              </button>
            )}
          </React.Fragment>
        ))}

        {/* Next Button */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`
            inline-flex items-center justify-center w-9 h-9 rounded-lg
            text-sm font-medium transition-all duration-200
            ${currentPage === totalPages
              ? 'text-surface-300 cursor-not-allowed'
              : 'text-surface-600 hover:bg-surface-100'
            }
          `}
        >
          <NavArrowRight strokeWidth={2} className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

export default Pagination
